// MFM 입력 유효성 검사 유틸리티 — CSS 인젝션 및 XSS 방지

const TIME_PATTERN = /^-?[0-9.]+s$/;
const COLOR_PATTERN = /^[0-9a-f]{3,6}$/i;

/**
 * CSS 시간 값 유효성 검사 (예: "1s", "0.5s", "-1s")
 * 유효한 경우 해당 문자열을 반환하고, 유효하지 않으면 null 반환
 */
export function validTime(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  if (!TIME_PATTERN.test(value)) return null;
  return value;
}

/**
 * 16진수 색상값 유효성 검사 (# 없이 3~6자리)
 * 유효한 경우 해당 문자열을 반환하고, 유효하지 않으면 null 반환
 */
export function validColor(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  if (!COLOR_PATTERN.test(value)) return null;
  return value;
}

/**
 * 문자열에서 부동소수점 숫자를 안전하게 파싱
 * 유효한 경우 숫자를 반환하고, 유효하지 않으면 null 반환
 */
export function safeParseFloat(value: unknown): number | null {
  if (typeof value !== 'string') return null;
  if (value === '') return null;
  const num = parseFloat(value);
  if (isNaN(num)) return null;
  return num;
}

/**
 * 숫자를 min과 max 사이로 제한
 */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}
